module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Kirst\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karen Kirst was born and raised in East Tennessee near the Great Smoky Mountains. In the fall of 2010, she got the happy news that Harlequin Love Inspired Historical wanted to publish her manuscript-a true blessing from God. When that line closed, she switched to Love Inspired Suspense. Now she divides her time between being a wife, homeschooling mom, and romance writer.   "), _c('BR'), _vm._v(" ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4pTgz4/tc-custom/9781488007729.jpg?1726871266014",
      "alt": "This image is the cover for the book Reclaiming His Past, Smoky Mountain Matches"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reclaiming His Past, Smoky Mountain Matches\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A desperate man without a past may find a future with a spirited young woman in this uplifting historical romance set in the Smokey Mountains.")]), _c('br'), _c('br'), _vm._v("The wounded stranger found on Jessica O’Malley’s property has no idea who he is. And Jessica would be foolish to trust him after being proven so wrong about a former suitor who turned out to be a criminal. But Jessica’s wariness toward the newcomer is soon turning to interest . . . and hope."), _c('br'), _c('br'), _vm._v("Until he knows his true identity, “Grant” can’t make a life in this quaint Tennessee town. He certainly shouldn’t be thinking so much about the feisty redhead with beautiful, guarded eyes. But even as he fights to keep a distance from Jessica, his feelings for her grow. And he can’t help but wonder if he’ll even want to return to his old life when his past is revealed.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0